// global.$ = require('jquery');
require('slick-carousel');
